import {
  IPulseAngularElementProps,
  PulseAngularElement,
} from './angular-element-decorator';
import { PULSE_ELEMENTS_CHUNK } from './model';

export function PulseContentElement(
  props: Pick<IPulseAngularElementProps, 'selector'>,
) {
  return PulseAngularElement({
    ...props,
    chunk: PULSE_ELEMENTS_CHUNK.CONTENT,
  });
}
